import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { MasterBrand } from '../../models/models';
import {
  formatMasterBrandLabel,
  isSameMasterBrand,
  normalizeMasterBrandValue,
} from '../../lib/masterBrandDisplay';
import { renderMasterBrandOption } from './MasterBrandOptionRender';

export interface MasterBrandSelectProps {
  id?: string;
  value: MasterBrand | null;
  onChange: (event: React.ChangeEvent<{}>, value: MasterBrand | null) => void;
  options: MasterBrand[];
  disabled?: boolean;
  label?: string;
  size?: 'small' | 'medium';
  loading?: boolean;
  style?: React.CSSProperties;
  className?: string;
  margin?: 'none' | 'dense' | 'normal';
  variant?: 'outlined' | 'filled' | 'standard';
  required?: boolean;
}

const MasterBrandSelect = (props: MasterBrandSelectProps) => {
  const {
    id,
    value,
    onChange,
    options,
    disabled = false,
    label = 'Brand',
    size = 'small',
    loading = false,
    style,
    className,
    margin = 'normal',
    variant = 'outlined',
    required = false,
  } = props;

  return (
    <Autocomplete
      id={id}
      className={className}
      style={style}
      options={options}
      size={size}
      disabled={disabled}
      loading={loading}
      value={normalizeMasterBrandValue(value)}
      onChange={onChange}
      getOptionLabel={(option) => formatMasterBrandLabel(option as MasterBrand)}
      getOptionSelected={(option, selectedValue) =>
        isSameMasterBrand(option as MasterBrand, selectedValue as MasterBrand)
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant={variant}
          margin={margin}
          required={required}
        />
      )}
      renderOption={(option, { inputValue }) =>
        renderMasterBrandOption(option as MasterBrand, inputValue)
      }
    />
  );
};

export default MasterBrandSelect;
